module.exports = __webpack_public_path__ + "static/img/main.7ed12c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/17/main.png
// module id = 8aaP
// module chunks = 1